var React = require('react');

function Info (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"10","key":0}),React.createElement("line",{"x1":"12","y1":"16","x2":"12","y2":"12","key":1}),React.createElement("line",{"x1":"12","y1":"8","x2":"12.01","y2":"8","key":2})]);
}

Info.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-info"};

module.exports = Info;

Info.default = Info;
